import Component from "vue-class-component";
import Form from "@/general/abstract/form/mixin/Form";

@Component({})
export default class SimpleForm<C> extends Form<C, C, C> {}
